import styled from "styled-components";
import Header from "../../components/common/Header";
import Form from "../../components/inquiry/Form";
import Footer from "../../components/common/Footer";

function Inquiry(){
    return(
        <Container>
            <Header />
            <Contents>
                <PartName>문의하기</PartName>
                <Form />
            </Contents>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
`

const Contents = styled.div`
    padding-top: 150px;
    padding-bottom: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const PartName = styled.div`
    color: #58AC65;
    font-size: 28px;
    font-weight: 600;
`


export default Inquiry;